import axios from "axios";

export default {
  data() {
    return {
      companyName: "WJKT - PTK" // Default fallback
    };
  },
  methods: {
    async fetchCompanyName() {
      try {
        const response = await axios.get("variables");
        const variables = response.data;
        const companyVar = variables.find(v => v.key === "nama_perusahaan");
        if (companyVar && companyVar.value) {
          this.companyName = companyVar.value;
        }
      } catch (err) {
        console.error("Error fetching company name:", err);
      }
    }
  },
  created() {
    this.fetchCompanyName();
  }
};
